const colors = {
  theodoGreen: '#6ABD9E',
  theodoBlue: '#0A0462',
  bordeaux: '#9f1724',
  white: '#FFFFFF',
  red: '#b51010',
}

export default colors
